import { gql } from '@apollo/client';

export const BOARDING_VISITED = gql`
  mutation BoardingVisited {
    onboardingVisited
  }
`;
